import axios from "axios";
import {
  FlightRecorderProjectDTO,
  FlightRecorderProjectInputDTO,
} from "../types/flight-recorder.types";

interface ProjectResponse {
  data: FlightRecorderProjectDTO[];
}

interface ProjectAccessRequest {
  projectId: string;
  workspaceId: string;
  userAccessList: Array<{
    email: string;
    role: string;
  }>;
}

class MfaAppService {
  private static instance: MfaAppService;
  private baseUrl = `${process.env.REACT_APP_API_BASE_URL}/flight-recorder`;
  private axiosInstance;
  private authToken: string | null = null;

  private constructor() {
    this.axiosInstance = axios.create({
      baseURL: this.baseUrl,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  public static getInstance(): MfaAppService {
    if (!MfaAppService.instance) {
      MfaAppService.instance = new MfaAppService();
    }
    return MfaAppService.instance;
  }

  async createProject(
    projectInput: FlightRecorderProjectInputDTO,
  ): Promise<string> {
    const { userId, ...bodyParams } = projectInput;
    const response = await this.axiosInstance.post<string>(
      "/project",
      bodyParams,
      {
        headers: {
          userid: userId,
          Authorization: `Bearer ${localStorage.getItem("pulselabs_user") ? JSON.parse(localStorage.getItem("pulselabs_user")!).token : ""}`,
        },
      },
    );
    return response.data;
  }

  async updateProject(
    id: string,
    projectInput: FlightRecorderProjectInputDTO,
  ): Promise<void> {
    const { userId, ...bodyParams } = projectInput;
    await this.axiosInstance.put(`/project/${id}`, bodyParams, {
      headers: {
        userid: userId,
        Authorization: `Bearer ${localStorage.getItem("pulselabs_user") ? JSON.parse(localStorage.getItem("pulselabs_user")!).token : ""}`,
      },
    });
  }

  // GetProjectsByWorkspaceId
  async getProjectsByWorkspaceId(
    workspaceId: string,
    userId: string,
    // take: number = 100, // default pagination
    // skip: number = 0,
  ): Promise<FlightRecorderProjectDTO[]> {
    const response = await this.axiosInstance.get<ProjectResponse>(
      `/project/workspace/${workspaceId}`,
      {
        params: {
          limit: 100,
          // take,
          // skip,
        },
        headers: {
          userId,
          Authorization: `Bearer ${localStorage.getItem("pulselabs_user") ? JSON.parse(localStorage.getItem("pulselabs_user")!).token : ""}`,
        },
      },
    );
    return response.data.data;
  }

  async getProject(
    id: string,
    userId: string,
  ): Promise<FlightRecorderProjectDTO> {
    const response = await this.axiosInstance.get<FlightRecorderProjectDTO>(
      `/project/${id}`,
      {
        headers: {
          userId,
          Authorization: `Bearer ${localStorage.getItem("pulselabs_user") ? JSON.parse(localStorage.getItem("pulselabs_user")!).token : ""}`,
        },
      },
    );
    return response.data;
  }

  async deleteProject(id: string, userId: string): Promise<void> {
    await this.axiosInstance.delete(`/project/${id}`, {
      headers: {
        userId,
        Authorization: `Bearer ${localStorage.getItem("pulselabs_user") ? JSON.parse(localStorage.getItem("pulselabs_user")!).token : ""}`,
      },
    });
  }

  public async sendSDKDocumentation(
    data: ProjectAccessRequest,
    userId: string,
  ): Promise<void> {
    try {
      await this.axiosInstance.post(`/project/access`, data, {
        headers: {
          userId,
          Authorization: `Bearer ${localStorage.getItem("pulselabs_user") ? JSON.parse(localStorage.getItem("pulselabs_user")!).token : ""}`,
        },
      });
    } catch (error) {
      console.error("Failed to send SDK documentation:", error);
      throw error;
    }
  }
}

export default MfaAppService;
